var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col md:flex-row w-full rounded-md border bg-white"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }